import { render, staticRenderFns } from "./declaracionSalud.vue?vue&type=template&id=280d0a6a"
import script from "./declaracionSalud.vue?vue&type=script&lang=js"
export * from "./declaracionSalud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports